import React, { useState } from "react";
import CivilianForm from "../components/CivilianFrom";
import DefenceOfficer from "../components/DefenceOfficer";
import ForeignerForm from "../components/ForeignerFrom";

// Import other category forms as needed (e.g., DefenceOfficerForm, GovernmentOfficerForm, etc.)

const MembershipRegistration = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [formikProps, setFormikProps] = useState({
    category: "Select Category of Applicant",
  });

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setFormikProps((prev) => ({ ...prev, category }));

    // Only set selectedCategory if it's a valid selection (not the default)
    if (category !== "Select Category of Applicant") {
      setSelectedCategory(category);
    } else {
      setSelectedCategory(null);
    }
  };

  const renderForm = () => {
    switch (selectedCategory) {
      case "Non Military":
      case "Corporate/Business":
      case "Government Officer":
        return <CivilianForm {...formikProps} />;
      case "Serving Defence Officer":
      case "Retired Defence Officer":
        return <DefenceOfficer {...formikProps} />;
      case "Foreigner/Diplomat":
        return <ForeignerForm {...formikProps} />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
      <div className="max-w-6xl mx-auto bg-[#fcfaec] rounded-xl p-6 md:p-10 space-y-10">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Membership Registration
          </h1>
          <p className="mt-3 text-xl text-gray-500">
            Please select your applicant category to begin
          </p>
        </div>

        <div className="bg-[#fcfaec] rounded-lg p-8 mb-10">
          <div className="space-y-6">
            <div className="">
              <label
                htmlFor="category"
                className="block text-lg font-medium text-gray-700 mb-2"
              >
                Membership Category
              </label>
              <select
                id="category"
                name="category"
                value={formikProps.category}
                onChange={handleCategoryChange}
                className="block w-full px-4 py-3 text-lg rounded-lg focus:ring-2 focus:ring-[#fcfaec] focus:border-[#fcfaec] transition duration-150"
              >
                <option disabled value="Select Category of Applicant">
                  Select Category of Applicant
                </option>
                <option className="py-2">Serving Defence Officer</option>
                <option className="py-2">Retired Defence Officer</option>
                <option className="py-2">Government Officer</option>
                <option className="py-2">Non Military</option>
                <option className="py-2">Corporate/Business</option>
                <option className="py-2">Foreigner/Diplomat</option>
              </select>
            </div>

            {selectedCategory && (
              <div className="pt-4 border-t border-gray-200">
                <div className="flex items-center">
                  <div className="flex-shrink-0 bg-gray-500 rounded-md p-2">
                    <svg
                      className="h-6 w-6 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-lg font-medium text-gray-900">
                      Selected Category
                    </h3>
                    <p className="text-gray-500">{selectedCategory}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Animated form container */}
        <div
          className={`transition-all duration-500 ease-in-out ${
            selectedCategory
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-4"
          }`}
        >
          {selectedCategory && renderForm()}
        </div>
      </div>
    </div>
  );
};

export default MembershipRegistration;
